import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import "../css/EmailVerified.css";

const EmailVerified = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("");

  useEffect(() => {
    document.title = "Email Verified - AplikasiKu";
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    setStatus(statusParam);
  }, [location.search]);

  return (
    <motion.div
      className="verified-container"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <motion.div
        className="verified-card"
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        <motion.img
          src="https://cdn-icons-png.flaticon.com/512/190/190411.png"
          alt="Success"
          className="verified-image"
          initial={{ rotateY: 180 }}
          animate={{ rotateY: 0 }}
          transition={{ duration: 0.6 }}
        />

        {status === "success" && <h1 className="title">Email Verified!</h1>}
        {status === "expired" && <h1 className="title">Verification Link Expired</h1>}
        {status === "invalid" && <h1 className="title">Invalid Verification Link</h1>}

        {status === "success" && (
          <p className="description">
            Your email has been successfully verified. You can now access your account.
          </p>
        )}
        {status === "expired" && (
          <p className="description">
            The verification link has expired. Please request a new verification email.
          </p>
        )}
        {status === "invalid" && (
          <p className="description">
            The verification link is invalid. Please check your email and try again.
          </p>
        )}

        <motion.button
          onClick={() => navigate("/login")}
          className="btn-login"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Proceed to Login
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default EmailVerified;
